var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxUserVoiceBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3BC7",
    d: "M8 12c2.28 0 4-1.72 4-4 0-2.28-1.72-4-4-4-2.28 0-4 1.72-4 4 0 2.28 1.72 4 4 4Zm0-6c1.178 0 2 .822 2 2s-.822 2-2 2-2-.822-2-2 .822-2 2-2Zm1 7H7c-2.757 0-5 2.243-5 5v1h2v-1c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3v1h2v-1c0-2.757-2.243-5-5-5Zm9.364-10.364L16.95 4.05A6.962 6.962 0 0 1 19 9a6.962 6.962 0 0 1-2.05 4.95l1.414 1.414A8.944 8.944 0 0 0 21 9a8.944 8.944 0 0 0-2.636-6.364Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3BC7",
    d: "M15.535 5.464 14.121 6.88c.567.565.88 1.318.88 2.12s-.313 1.555-.88 2.12l1.414 1.416A4.967 4.967 0 0 0 17 9a4.967 4.967 0 0 0-1.465-3.536Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxUserVoiceBlue);
export default __webpack_public_path__ + "static/media/bx-user-voice-blue.275d1e65651ddd0fb29adf59de4b4aa1.svg";
export { ForwardRef as ReactComponent };